module.exports = __webpack_public_path__ + "img/gztiao.6393dd1f.png";